module.exports = {
  title: '技术资料详情',
  route: {
    path: '/infomation-dynamic',
    children: {
      path: 'tech-detail',
    },
  },
};
